import {
  createErrorSelector,
  createLoadingSelector,
} from '../../utils/reduxUtils';
import { GET_REVIEWS } from '../actions';

export const ratingSelector = (period: string) => (state: any) =>
  state.rating[period];

export const ratingLoadingSelector = createLoadingSelector([GET_REVIEWS]);
export const ratingErrorSelector = createErrorSelector([GET_REVIEWS]);
export const ratingPeriodSelector = (state: any) => state.rating.period;
